import { c as _c } from "react/compiler-runtime";
import { Box, colors, IconSearch2 as IconGlobalSearch, Text } from '@newfront-insurance/core-ui';
import { useMemo, type JSX } from 'react';
import styled from 'styled-components';
interface Props {
  currentQuery: string;
  onClick: () => void;
  suggestion: string;
}
export function Suggestion(t0) {
  const $ = _c(21);
  const {
    currentQuery,
    suggestion,
    onClick
  } = t0;
  let t1;
  let boundary = 0;
  for (let i = 0; i < currentQuery.length; i = i + 1, i) {
    if (i >= suggestion.length || currentQuery.charAt(i) !== suggestion.charAt(i)) {
      break;
    }
    boundary = boundary + 1;
  }
  let t2;
  if ($[0] !== boundary || $[1] !== suggestion) {
    t2 = suggestion.slice(0, boundary);
    $[0] = boundary;
    $[1] = suggestion;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== boundary || $[4] !== suggestion) {
    t3 = suggestion.slice(boundary);
    $[3] = boundary;
    $[4] = suggestion;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== t2 || $[7] !== t3) {
    t4 = [t2, t3];
    $[6] = t2;
    $[7] = t3;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  t1 = t4;
  const [highlighted, rest] = t1;
  let t5;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <IconGlobalSearch />;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = {
      marginLeft: 12
    };
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== highlighted) {
    t7 = <Text display="inline" weight={700}>{highlighted}</Text>;
    $[11] = highlighted;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  let t8;
  if ($[13] !== rest) {
    t8 = <Text display="inline">{rest}</Text>;
    $[13] = rest;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  let t9;
  if ($[15] !== t7 || $[16] !== t8) {
    t9 = <Box style={t6}>{t7}{t8}</Box>;
    $[15] = t7;
    $[16] = t8;
    $[17] = t9;
  } else {
    t9 = $[17];
  }
  let t10;
  if ($[18] !== onClick || $[19] !== t9) {
    t10 = <StyledSuggestionItem onClick={onClick}>{t5}{t9}</StyledSuggestionItem>;
    $[18] = onClick;
    $[19] = t9;
    $[20] = t10;
  } else {
    t10 = $[20];
  }
  return t10;
}
const StyledSuggestionItem = styled.div`
  cursor: pointer;
  display: block;
  margin: 0;
  margin-bottom: 15px;
  font-style: italic;
  display: flex;
  align-items: center;

  svg {
    color: ${colors.steel[300]};
  }
`;